import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons'
import { Col, Form, Row, Switch, Tabs } from 'antd'
import Button from 'components/Button/index'
import Control from 'components/Control/Control'
import Flex from 'components/Flex'
import AntdInput from 'components/Form/Input'
import Password from 'components/Form/Password'
import AntdSelect from 'components/Select'
import Uploader from 'components/Uploader/Uploader'
import Camera from 'components/icons/Camera'
import CheckedWhite from 'components/icons/CheckedWhite'
import LockIcon from 'components/icons/LockIcon'
import ChangePhoneNum from 'modules/ManageProfile/Components/PhoneModel/index'
import {
  ButtonCenterPadding,
  ChangeSpan,
  FormItem,
  ImageColPadding,
  ImageFlex,
  ImageTag,
  ImageUploadWrapper,
  InputLabel,
  LabelColPadding,
  MessageDiv,
  RowPadding,
  SectionWrapper,
  StyledInput,
  StyledInputDiv,
  StyledSelectDiv,
  StyledTabs,
  TabDiv,
  TopHeader,
  TopHeading,
} from 'modules/ManageProfile/Styles/style'
import { deleteFile } from 'modules/ManageProfile/actions'
import React, { Fragment, useEffect, useState } from 'react'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { encrypt } from 'utils/encrypt'
import { removeDuplicatesFromArray } from 'utils/removeDuplicatesFromArray'
import CONSTANTS from '../../utils/passwordValidation'

const { TabPane } = Tabs
const iconRender = visible => {
  if (visible) return <EyeTwoTone />
  else return <EyeInvisibleOutlined />
}
const ManageProfile = ({
  userId,
  changePassword,
  getUserRoles,
  userData,
  userRole,
  updateNotification,
  checkOtp,
  SendOtp,
  updateUserData,
  getUserInfo,
  getListOfCountries,
}) => {
  const [file, setFile] = useState(null)
  const [submitkey, setSubmitkey] = useState('profileForm')
  const [phoneModel, setPhoneModel] = useState(false)
  const [phoneOTP, setPhoneOTP] = useState(false)
  const [phoneVerify, setPhoneVerify] = useState(false)
  const [enteredPhone, setEnteredPhone] = useState()
  const [form] = Form.useForm()
  const [formPwd] = Form.useForm()
  const [formsetting] = Form.useForm()
  const formRef = React.createRef()
  const [email, setEmail] = useState()

  const [countryCodeSearch, setCountryCodeSearch] = useState('')
  const [countryCodeList, setCountryCodeList] = useState([])

  useEffect(() => {
    getUserInfo()
    getUserRoles()
  }, [])

  useEffect(() => {
    form.setFieldsValue({
      profilePicture: userData?.profile_picture,
      firstName: userData?.first_name,
      lastName: userData?.last_name,
      email: userData?.email,
      role: getRoleName(userData?.admin_role_id),
      countryCode: userData?.country_code,
      phoneNumber: userData?.phone_number,
    })
    formsetting.setFieldsValue({
      email: userData?.notification_subscription?.email,
    })

    setFile(userData?.profile_picture || null)
    setEmail(userData?.notification_subscription?.email)
  }, [userData])

  useEffect(() => {
    form.setFieldsValue({ profilePicture: file })
  }, [file])

  const getCurrency = async ({ setState, searchValue }) => {
    const { data, status } = await getListOfCountries({
      phoneCodeSearch: searchValue,
      pageLimit: 500,
    })

    if (status >= 200 && status <= 300) {
      setState(removeDuplicatesFromArray(data?.data?.result, 'phone_code'))
    }
  }

  useEffect(() => {
    let getData
    if (countryCodeSearch) {
      getData = setTimeout(() => {
        getCurrency({
          setState: setCountryCodeList,
          searchValue: countryCodeSearch,
        })
      }, 500)
    } else {
      getCurrency({
        setState: setCountryCodeList,
        searchValue: countryCodeSearch,
      })
    }

    return () => clearTimeout(getData)
  }, [countryCodeSearch])

  const getRoleName = id => {
    let roleName = userRole?.filter(data => data?.id === id)[0]?.name
    return roleName || '-'
  }

  const submitHandler1 = async values => {
    let firstName = values?.firstName?.trim()
    let lastName = values?.lastName?.trim()
    let payload = {
      firstName: firstName,
      lastName: lastName,
      profilePicture: values?.profilePicture,
    }

    updateUserData(payload)
    getUserInfo()
  }

  const submitHandler2 = async values => {
    if (values.currentPwd === values.newPwd) {
    formRef.current.setFields([
      {
        name: 'newPwd',
        errors: ["Current password and New password can't be same."],
      },
    ])
    return
  }
    let payload = {
      currentPassword: await encrypt(values.currentPwd),
      newPassword: await encrypt(values.newPwd),
    }

    // if (values.confirmPwd === values.newPwd) {
      // let response = await changePassword(payload)

      // if (response?.status >= 200 && response?.status < 300) {
      //   if (values.confirmPwd !== values.newPwd) {
    if (values.confirmPwd !== values.newPwd) {  
    formRef.current.setFields([
      {
        name: "confirmPwd",
        errors: ["Confirm password does not match."],
      },
    ]);
    return;
  }
  let response = await changePassword(payload);
  if (response?.status >= 200 && response?.status < 300) {
    formPwd.resetFields();
    SuccessMessage("Password Changed Successfully");
    return;
  }

  let errorMessage =
    response?.response?.data?.message?.message ||
    response?.response?.data?.message ||
    response?.message ||
    "Invalid current password";

  if (
    response?.response?.status === 400 ||
    errorMessage.toLowerCase().includes("invalid") ||
    errorMessage.toLowerCase().includes("incorrect") ||
    errorMessage.toLowerCase().includes("current password")
  ) {
    errorMessage = "Invalid current password";

    formRef.current.setFields([
      {
        name: "currentPwd",
        errors: ["Invalid current password"],
      },
    ]);
  }
  ErrorMessage(errorMessage);
};

  const submitHandler3 = async values => {
    let payload = {
      email: email,
      whatsapp: false,
    }
    const response = await updateNotification(userId, payload)

    if (response) {
      SuccessMessage('Notification Updated Successfully')
      getUserInfo()
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const onChangeEmail = () => {
    formsetting.setFieldsValue({ email: !email })
    setEmail(!email)
  }

  const onPhoneEntered = e => {
    setEnteredPhone(e.target.value)
  }

  const changePhone = () => {
    setPhoneModel(true)
    getUserInfo()
  }
  const onChange = key => {
    setSubmitkey(key)
  }

  const onRemoveImage = async () => {
    let response = deleteFile(file)
    if (response) {
      setFile(null)
      form.setFieldsValue({ profilePicture: '' })
      SuccessMessage('File deleted successfully!')
    } else {
      ErrorMessage('Failed to delete the file!')
    }
  }

  return (
    <>
      <SectionWrapper column>
        <TopHeader row spaceBetween alignCenter>
          <TopHeading flexStart>Manage Profile</TopHeading>
          <Flex>
            <Button.Primary
              icon={<CheckedWhite />}
              height="32px"
              htmlType="submit"
              form={submitkey}
              text={'Save Changes'}
              width={'144px'}
            />
          </Flex>
        </TopHeader>
        <TabDiv>
          <StyledTabs defaultActiveKey={submitkey} onChange={onChange}>
            <TabPane tab="Profile Settings" key="profileForm">
              <Form
                scrollToFirstError
                onFinish={submitHandler1}
                id={'profileForm'}
                form={form}
                layout="vertical"
              >
                <Row>
                  <ImageFlex row centerVertically>
                    <ImageColPadding>
                      <ImageUploadWrapper column alignCenter center>
                        {!file && (
                          <Fragment>
                            <Control column alignCenter>
                              <Camera />
                            </Control>
                            <Control column alignCenter top={'3px'}>
                              <Control column alignCenter>
                                Max file size: 2MB
                              </Control>
                              <Control column alignCenter>
                                Dimension: 130*130
                              </Control>
                              <Control column alignCenter>
                                File format: .png, .jpeg
                              </Control>
                            </Control>
                          </Fragment>
                        )}

                        {file && <ImageTag src={file} />}
                      </ImageUploadWrapper>

                      {!file && (
                        <Uploader
                          setFile={setFile}
                          showTextUploder={!file}
                          fileName={
                            userData?.first_name
                              ?.toLowerCase()
                              .replace(/\s/g, '') + '_profile'
                          }
                        />
                      )}
                      <FormItem
                        name={'profilePicture'}
                        padding={true}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: 'Please upload a image!',
                        //   },
                        // ]}
                      />
                    </ImageColPadding>

                    <ButtonCenterPadding>
                      {file ? (
                        <Flex>
                          <Uploader
                            isDelete={true}
                            file={file}
                            setFile={setFile}
                            showButtonUploder={file}
                            fileName={
                              userData?.first_name
                                ?.toLowerCase()
                                .replace(/\s/g, '') + '_profile'
                            }
                          />
                          &nbsp; &nbsp;
                          <Button.Secondary
                            text="Remove"
                            onClick={onRemoveImage}
                            height={'32px'}
                            width="76px"
                          />
                        </Flex>
                      ) : null}
                    </ButtonCenterPadding>
                  </ImageFlex>
                </Row>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>First Name</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <AntdInput
                      placeholder="First name"
                      name={'firstName'}
                      maxLength={120}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter first name!',
                        },
                        {
                          min: 3,
                          max: 120,
                          message:
                            'Please Enter Valid Name,Minimum 3 characters , Maximum 120 characters',
                        },
                      ]}
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>Last Name</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <AntdInput
                      placeholder="Last name"
                      name={'lastName'}
                      maxLength={20}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter Last name!',
                        },
                        {
                          max: 20,
                          message:
                            'Please Enter Valid Name,Maximum length is 20 characters',
                        },
                      ]}
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>Email ID</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <AntdInput
                      placeholder="eg:harry@yahoo.com"
                      name={'email'}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter primary email!',
                        },
                      ]}
                      suffix={<LockIcon />}
                      disabled={true}
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>Role</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <AntdInput
                      placeholder="Role"
                      name={'role'}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter role',
                        },
                      ]}
                      suffix={<LockIcon />}
                      disabled={true}
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>Phone Number</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <Control>
                      <StyledSelectDiv>
                        <FormItem name="countryCode" width={'100%'}>
                          <AntdSelect
                            showSearch
                            OptionData={countryCodeList}
                            width="100%"
                            disabled={true}
                            bordered={false}
                            placeholder="91"
                            nameParam="phone_code"
                            valueParam="phone_code"
                            onSearch={value => setCountryCodeSearch(value)}
                            onSelect={() => setCountryCodeSearch('')}
                            filterOption={false}
                          />
                        </FormItem>
                      </StyledSelectDiv>
                      <StyledInputDiv>
                        <StyledInput
                          width="100%"
                          type="tel"
                          placeholder="Eg: 1010101010"
                          disabled={true}
                          rules={[
                            {
                              required: true,
                              message: 'Please Enter phone number!',
                            },
                          ]}
                          name={'phoneNumber'}
                          suffix={
                            <ChangeSpan onClick={changePhone}>
                              Change
                            </ChangeSpan>
                          }
                        />
                      </StyledInputDiv>
                    </Control>
                  </Col>
                </RowPadding>
              </Form>
            </TabPane>
            <TabPane tab="Change Password" key="ChangePasswordForm">
              <Form
                scrollToFirstError
                onFinish={submitHandler2}
                id={'ChangePasswordForm'}
                form={formPwd}
                ref={formRef}
                layout="vertical"
              >
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>Current Password</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <Password
                      placeholder="Enter Current Password"
                      name={'currentPwd'}
                      type={'password'}
                      maxLength={20}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter the current password!',
                        },
                        {
                          pattern: CONSTANTS.REGEX.PASSWORD,
                          message:
                            'Password must contain atleast 1 letter, 1 number, 1 symbol. Minimum length is 8 characters.',
                        },
                      ]}
                      iconRender={iconRender}
                    />
                  </Col>
                </RowPadding>
                <MessageDiv>
                  Password should be alphanumeric with special characters.
                </MessageDiv>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>New Password</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <Password
                      placeholder="Enter New Password"
                      name={'newPwd'}
                      maxLength={20}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter the new password!',
                        },
                        {
                          pattern: CONSTANTS.REGEX.PASSWORD,
                          message:
                            'Password must contain atleast 1 letter, 1 number, 1 symbol. Minimum length is 8 characters.',
                        },
                      ]}
                      iconRender={iconRender}
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>Confirm Password</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <Password
                      placeholder="Confirm Password"
                      name={'confirmPwd'}
                      maxLength={20}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter the confirm password!',
                        },
                        {
                          pattern: CONSTANTS.REGEX.PASSWORD,
                          message:
                            'Password must contain atleast 1 letter, 1 number, 1 symbol. Minimum length is 8 characters.',
                        },
                      ]}
                      iconRender={iconRender}
                    />
                  </Col>
                </RowPadding>
              </Form>
            </TabPane>

            <TabPane tab="Notification Settings" key="settingForm">
              <Form
                scrollToFirstError
                onFinish={submitHandler3}
                id={'settingForm'}
                form={formsetting}
                layout="vertical"
              >
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>Email Notification</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <Switch
                      name={'email'}
                      onChange={onChangeEmail}
                      checked={email}
                    />
                  </Col>
                </RowPadding>
              </Form>
            </TabPane>
          </StyledTabs>
        </TabDiv>
      </SectionWrapper>
      <ChangePhoneNum
        phoneOTP={phoneOTP}
        setPhoneOTP={setPhoneOTP}
        phoneVerify={phoneVerify}
        setPhoneVerify={setPhoneVerify}
        phoneModel={phoneModel}
        setPhoneModel={setPhoneModel}
        onPhoneEntered={onPhoneEntered}
        enteredPhone={enteredPhone}
        SendOtp={SendOtp}
        checkOtp={checkOtp}
        userId={userId}
        getUserInfo={getUserInfo}
        setenteredPhone={setEnteredPhone}
        setCountryCodeSearch={setCountryCodeSearch}
        getListOfCountries={getListOfCountries}
        countryCodeList={countryCodeList}
        countryCodeSearch={countryCodeSearch}
        setCountryCodeList={setCountryCodeList}
        userData={userData}
      />
    </>
  )
}
export default ManageProfile
